/**
 * The four settings sections, in tab order.
 *
 * Its own module because both the route (which validates `?tab=`) and the page
 * (which renders the tabs) need it, and importing the page from the router
 * while the page imports the route is the cycle this avoids.
 */
export const SETTINGS_SECTIONS = ['recording', 'access', 'branding', 'integrations'] as const

export type SettingsSection = (typeof SETTINGS_SECTIONS)[number]

export const SECTION_LABELS: Record<SettingsSection, string> = {
  recording: 'Recording',
  access: 'Access',
  branding: 'Branding',
  integrations: 'Integrations',
}
